import React from 'react';
import { FadeIn, CTAButton, Section, Accent, Stars } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, Globe2, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
export const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/a5wDcjcYkyBHi6BisQcSi3/MOCKUP_PNG.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/v8gnCg5mXtVLgwG8WBwDon/Libros%20FUNCIONAL.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100% PDF'
  }, {
    icon: ZapIcon,
    label: 'Acceso en 5 min'
  }, {
    icon: LayersIcon,
    label: '365 sesiones'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-284" data-mp="e2ez937krfm7">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-285" data-mp="1kg4nwz3y47wx" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)] items-center justify-items-center gap-3 px-5 pb-10 pt-4 sm:gap-6 sm:pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:justify-items-stretch lg:gap-x-12 lg:gap-y-8" data-id="element-286" data-mp="1pefv122uw4bg">
        {/* Headline */}
        <FadeIn className="flex w-full min-w-0 flex-col items-center text-center lg:col-start-1 lg:row-start-1 lg:items-start lg:self-end lg:text-left" data-id="element-287" data-mp="1882pp06v6hy4">
          <p className="mb-2 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-400 sm:mb-4 sm:text-xs" data-id="element-288" data-mp="ybzphzvkotdt">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" aria-hidden="true" data-id="element-289" data-mp="tjeuiv0xka8p" />
            MEGAPACK FUNCIONAL 365™
          </p>
          <h1 className="w-full break-words pr-[0.06em] font-display text-[clamp(28px,8.6vw,40px)] font-black uppercase italic leading-[1] tracking-tight text-white sm:text-5xl md:text-6xl lg:pr-0 lg:text-[64px]" data-id="element-290" data-mp="kkl3rlaa6e32">
            Organiza todas tus clases de <Accent data-id="element-291" data-mp="amdnz5rqa22n">funcional.</Accent>
            <span className="mt-1 block text-slate-400" data-id="element-292" data-mp="y9lkuhflsgh">En 5 minutos.</span>
          </h1>
          <p className="mx-auto mt-2.5 max-w-[340px] text-[13.5px] leading-snug text-slate-300 sm:mt-5 sm:max-w-md sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-293" data-mp="5xcoo9dupolt">
            Tu sistema completo de entrenamiento funcional: 365 días de sesiones,
            calentamientos, circuitos, progresiones y planificación lista para aplicar.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.05} className="flex w-full min-w-0 justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-294" data-mp="jr3nontyhq3a">
          <a href="#pricing" className="group block w-full" aria-label="Ver la oferta" data-id="element-295" data-mp="9z7m32snvhub">
            <img src={HERO_MOCKUP} alt="MEGAPACK Funcional 365 — los 6 tomos, el pack de bonos y el acceso digital en tablet, computadora y celular" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[380px] object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1 sm:max-w-[560px] lg:max-w-none" data-id="element-296" data-mp="ey12p438voyp" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.1} className="flex w-full min-w-0 max-w-[420px] flex-col items-center sm:max-w-none lg:col-start-1 lg:row-start-2 lg:items-start lg:self-start" data-id="element-297" data-mp="31v22gz431ufg">
          <ul className="mb-3 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mb-5 sm:gap-2 lg:justify-start" data-id="element-298" data-mp="2wxtj4v777kcm">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-200 sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-xs md:text-sm" data-id="element-299" data-mp="2494q7jgaqlby">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-300" data-mp="3tkygloq86aeg" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-301" data-mp="3pjlenpq96rct">
            Quiero el MEGAPACK ahora
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-302" data-mp="oqq88q8tvosg" />
          </CTAButton>
          <div className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-[11px] text-slate-400 sm:mt-4 sm:gap-x-4 sm:text-xs lg:justify-start" data-id="element-303" data-mp="xpbzrawa2e5d">
            <span className="flex items-center gap-1.5" data-id="element-304" data-mp="17ob0m7asx5ht">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-305" data-mp="17lotg8rtos04" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-306" data-mp="1gg35m2h23mf0">
              <Lock size={14} aria-hidden="true" data-id="element-307" data-mp="1ggmpvpu6imw7" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-308" data-mp="1le4nik2qxfow">
              <Globe2 size={14} className="text-sky-400" aria-hidden="true" data-id="element-309" data-mp="1qe97wl6ryuke" /> Pagas en tu moneda local
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'coaches confían'
  }, {
    value: '6',
    label: 'Tomos Completos'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-310" data-mp="35xqjf1znzntu">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-311" data-mp="30zfcp04o1tfu">
        {stats.map((s, i) => <div key={s.label} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-312" data-mp="2f6ti64gku27" data-mpi={i}>
            <dt className="sr-only" data-id="element-313" data-mp="3ovt63a4qp8oh">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-314" data-mp="3oui1j83gzwwb">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-315" data-mp="l7j5lkkwz9pj">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-316" data-mp="gfhljchi8eoy" />}
            </dd>
          </div>)}
      </dl>
    </div>;
};
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-317" data-mp="2fnhj4203s58v">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-318" data-mp="2fp105utl2kbp">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.15)} data-id="element-319" data-mp="20whanwzcwbcq" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-320" data-mp="25w3l5ynsvdhu">
            <Stars data-id="element-321" data-mp="1rwc4fq5wfj05" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-322" data-mp="1rzzx6n3is1dt">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-323" data-mp="1i0932mivfoe9">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-324" data-mp="1myiv4o9au8vn">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-325" data-mp="3cbntz6nmbtvl">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-326" data-mp="3hctp1b4r3t8a">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-327" data-mp="15ootdpbpq1w4">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Problem = () => {
  const painPoints = ['Llegas al gimnasio sin saber exactamente qué clase dar hoy', 'Pierdes horas buscando ejercicios, armando circuitos y pensando como adaptarlas para todo a tu grupo.', 'Terminas repitiendo entrenamientos porque no tienes suficientes sesiones listas para elegir.', 'Quieres un programa anual estructurado pero no tienes tiempo de planificarlo.', 'Buscas trabajar con mayor variedad y progresión, pero sientes que tu grupo se estanca.', 'Fin de semana buscando ideas. El lunes se siente improvisado. Y el ciclo vuelve a empezar.'];
  return <Section className="bg-slate-900/40" data-id="element-328" data-mp="1tcpwgiq4gq45">
      <FadeIn className="mx-auto mb-10 max-w-4xl text-center md:mb-14" data-id="element-329" data-mp="3zcomjiswjya">
        <h2 className="mx-auto font-display text-[30px] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[44px] md:text-[60px] lg:text-[68px]" data-id="element-330" data-mp="41pcfdb8poj9">
          Si eres profe de <Accent data-id="element-331" data-mp="39b5pkcymrp65">funcional,</Accent>
          <br data-id="element-332" data-mp="3ebjq79xwjwu5" /> esto te resultará familiar...
        </h2>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 md:mb-24 md:grid-cols-2" data-id="element-333" data-mp="3j2t9ztwrs5y4">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 border-b border-white/5 py-3.5" data-id="element-334" data-mp="3o2e862448a9s">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-335" data-mp="2qenp975pugya">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-336" data-mp="2vcfiq5m0eb4l" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-337" data-mp="30b8tvrdtpq1l">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 max-w-3xl text-center md:mb-16" data-id="element-338" data-mp="34fgkxv7r7i2z">
        <h3 className="mx-auto pr-[0.06em] font-display text-[clamp(26px,8vw,34px)] font-black uppercase italic leading-[1.08] tracking-tight text-white sm:text-[42px] md:text-[56px] lg:text-[64px]" data-id="element-339" data-mp="fmunvslfa26v">
          <span className="block sm:inline" data-id="element-340" data-mp="244nno4rphh5l">¿Sigues</span>{' '}
          <span className="block sm:inline" data-id="element-341" data-mp="2043pqyzb69ie">improvisando</span>{' '}
          <span className="block sm:inline" data-id="element-342" data-mp="204x0sc5avl6c">tus</span>{' '}
          <span className="block whitespace-nowrap sm:inline" data-id="element-343" data-mp="1vclr4hkrcl0l">
            <Accent data-id="element-344" data-mp="1vb2c0uau8g0e">entrenamientos?</Accent>
          </span>
        </h3>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-[15px] leading-relaxed text-slate-300 md:mt-8 md:text-lg" data-id="element-345" data-mp="1qe2228avat40">
          <p data-id="element-346" data-mp="1lcuvudodi1zg">
            Elegiste esta profesión porque te apasiona el entrenamiento funcional
            y ver progresar a tu grupo.
          </p>
          <p data-id="element-347" data-mp="1cfkh2iccjups">
            No importa si tienes años de experiencia o apenas estás comenzando:{' '}
            <span className="text-white" data-id="element-348" data-mp="17gho3w9n5ey6">el problema suele ser el mismo.</span>
          </p>
          <p data-id="element-349" data-mp="36sttoj06vwc9">
            Pasas más tiempo <strong className="font-semibold text-white" data-id="element-350" data-mp="36rsjshuwtfw4">BUSCANDO</strong> qué
            enseñar que realmente <strong className="font-semibold text-white" data-id="element-351" data-mp="31u8tukouneoc">ENSEÑANDO</strong>.
          </p>
          <p data-id="element-352" data-mp="ia3ewvz4pd00">
            Y mientras sacrificas tus domingos armando clases, otros coaches siguen
            avanzando.
          </p>
          
          
          
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-353" data-mp="rbt6q2wxadyb">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-354" data-mp="md8fuu3k96mj">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.1] tracking-tight text-white md:text-4xl" data-id="element-355" data-mp="3usjtvukmz7n8">
            ¿Y si esta fuera la <Accent data-id="element-356" data-mp="3qtazcnhrv5qm">última clase</Accent>
            <br data-id="element-357" data-mp="8d78cvssj0y3" /> que preparas así?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-358" data-mp="8fblm4ckxcb1">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-359" data-mp="3lyvfps94xg6">
          <TrophyIcon size={14} aria-hidden="true" data-id="element-360" data-mp="373qsvjp5q9lr" />
          Sistema n°1 para profesores de Funcional
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-361" data-mp="1mkwvakd80das">
          MEGAPACK Funcional <Accent data-id="element-362" data-mp="1rdg6jaofqwcf">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-363" data-mp="1dla22lunadst">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo resuelto.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-364" data-mp="269p5eb4ez7ob">
          <ProductVideo src={PRODUCT_VIDEO} label="Vista previa de los tomos del MEGAPACK Funcional 365" className="block w-full object-cover" data-id="element-365" data-mp="2aa7x856b4dqi" />
        </div>
      </FadeIn>
    </Section>;
};